
// const BASE_URL = "https://dispax-backend.vercel.app/api/v1";

import axios from "axios";


const BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://dispax-semisoluton.vercel.app/api/v1";

const token = localStorage.getItem('accessToken');






export const registerCompany = async (data) => {
  try {
    const headers = {
      "Content-Type": "application/json",
    };

    const response = await fetch(`${BASE_URL}/user/registration`, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Registration failed with status ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
};

export const getAllLinkData = async (params = {}) => {
  try {
    const response = await axios.get(`${BASE_URL}/static/linkData/All`, {
      headers: {
        "Content-Type": "application/json",
      },
      params,
    });

    console.log("getAllLinkData API response:", response.data);

    // If backend returns { data: [...] } adjust here
    return response.data;
  } catch (error) {
    const errMsg = error?.response?.data || error.message;
    console.error("API Error (getAllLinkData):", errMsg);
    throw errMsg;
  }
};

export const addClient = async (data) => {
  try {
    // Get token from localStorage
    const token = localStorage.getItem('accessToken');

    const response = await axios.post(`${BASE_URL}/driversAndFleet/addUser`, data, {
      headers: {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }), // add token if exists
      },
    });

    const result = response.data;

    // Optionally store new token if returned


    return result;
  } catch (error) {
    if (error.response) {
      console.error("API Error:", error.response.data.message || error.response.statusText);
      throw new Error(error.response.data.message || `Request failed with status ${error.response.status}`);
    } else if (error.request) {
      console.error("No response from server:", error.request);
      throw new Error("No response from server");
    } else {
      console.error("Error:", error.message);
      throw new Error(error.message);
    }
  }
};



export const paymentForInvoices = async (id, email) => {
  try {
    const token = localStorage.getItem('accessToken');

    const response = await axios.post(
      `${BASE_URL}/user/paymentForInvoices/${id}`,
      { email }, // body with email
      {
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      console.error(
        "API Error:",
        error.response.data?.message || error.response.statusText
      );
      throw error.response.data;
    } else if (error.request) {
      console.error("No response from server:", error.request);
      throw new Error("No response from server");
    } else {
      console.error("Error:", error.message);
      throw new Error(error.message);
    }
  }
};

export const updateInvoices = async (invoiceId, data) => {
  try {
    const token = localStorage.getItem('accessToken');

    const response = await axios.post(
      `${BASE_URL}/user/updateInvoices/${invoiceId}`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      console.error(
        "API Error (updateInvoices):",
        error.response.data?.message || error.response.statusText
      );
      throw error.response.data;
    } else if (error.request) {
      console.error("No response from server:", error.request);
      throw new Error("No response from server");
    } else {
      console.error("Error:", error.message);
      throw new Error(error.message);
    }
  }
};
export const getAllClients = async (params = {}) => {
  try {
    const token = localStorage.getItem('accessToken');

    const response = await axios.get(`${BASE_URL}/driversAndFleet/getAllUser`, {
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      params, // safe because default is {}
    });

    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data?.message || error.message || "Something went wrong",
    };
  }
};



export const socialLogin = async (data) => {
  try {
    const headers = {
      "Content-Type": "application/json",
    };

    const response = await fetch(`${BASE_URL}/user/socialLogin`, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Social login failed with status ${response.status}`);
    }

    console.log('result', result)
    if (result.status === 200) {
      localStorage.setItem('userId', result.data._id);
      localStorage.setItem('accessToken', result.accessToken);
    }

    return result;
  } catch (error) {
    console.error("Social Login API Error:", error.message);
    throw error;
  }
};
export const forgetPassword = async (data) => {
  try {
    const headers = {
      "Content-Type": "application/json",
    };

    const response = await fetch(`${BASE_URL}/user/forgetPassword`, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Forget Password failed with status ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
};

export const deleteDriver = async (userId) => {
  try {
    const token = localStorage.getItem('accessToken');
    const response = await fetch(
      `${BASE_URL}/driversAndFleet/deleteDriver/${userId}`,
      {
        method: "DELETE",
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data?.message || "Failed to delete driver");
    }

    return data;
  } catch (error) {
    console.error("API Error in deleteDriver:", error);
    throw error.message || "Something went wrong while deleting driver";
  }
};


export const updateDriver = async (userId, driverData) => {
  try {

    for (let pair of driverData.entries()) {
      console.log(pair[0] + ', ' + pair[1]);
    }

    const token = localStorage.getItem("accessToken");
    const response = await fetch(
      `${BASE_URL}/driversAndFleet/editDriver/${userId}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: driverData,
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data?.message || "Failed to update driver");
    }

    return data;
  } catch (error) {
    console.error("API Error in updateDriver:", error);
    throw error.message || "Something went wrong while updating driver";
  }
};

export const changePasswords = async (userId, passwordData) => {
  try {
    const response = await fetch(`${BASE_URL}/user/changePassword/${userId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(passwordData),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw errorData || { message: "Something went wrong while changing password." };
    }

    return await response.json();
  } catch (error) {
    console.error("API Error in changePassword:", error);
    throw error.message || "Something went wrong while changing password.";
  }
};

export const verifyOtp = async (passwordData) => {
  try {
    const response = await fetch(`${BASE_URL}/user/forgotVerifyOtp`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(passwordData),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw errorData || { message: "Something went wrong while verifying OTP." };
    }

    return await response.json();
  } catch (error) {
    console.error("API Error in verifyOtp:", error);
    throw error.message || "Something went wrong while verifying OTP.";
  }
};





export const otpSend = async (data) => {
  try {
    const response = await fetch(`${BASE_URL}/user/forgetPassword`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    // Try to parse JSON safely
    let result;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      result = await response.json();
    } else {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    // Handle error response
    if (!response.ok) {
      throw new Error(result?.message || `Request failed with status ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("API Error in otpSend:", error);
    throw new Error(error.message || "Something went wrong while sending OTP.");
  }
};




export const registrationVerification = async (data) => {
  try {
    const headers = {
      "Content-Type": "application/json",
    };

    const response = await fetch(`${BASE_URL}/user/registrationVerification`, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Verification failed with status ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
};

export const login = async (data) => {
  try {
    const headers = {
      "Content-Type": "application/json",
    };

    const response = await fetch(`${BASE_URL}/user/signin`, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      if (response.status === 403) {
        throw new Error(result.message || "Your account access has been revoked. Contact your dispatching company.");
      }
      throw new Error(result.message || `Login failed with status ${response.status}`);
    }

    if (result.data && result.data.userId && result.accessToken) {
      localStorage.setItem('userId', result.data.userId);
      localStorage.setItem('accessToken', result.accessToken);
    }

    return result;
  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
};

export const changePassword = async (data) => {
  try {
    const userId = localStorage.getItem('userId');
    if (!userId) {
      throw new Error('User ID not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
    };

    const response = await fetch(`${BASE_URL}/user/changePassword/${userId}`, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Password change failed with status ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
};


export const getPackage = async () => {
  try {
    const response = await fetch(`${BASE_URL}/static/getPackage`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Fetch packages failed with status ${response.status}`);
    }

    return result.data;
  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
};


export const checkOutPackageById = async (userId, packageId) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/user/checkOutPackageById/${packageId}`, {
      method: "POST",
      headers,
      body: JSON.stringify({ userId }),
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Checkout failed with status ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
};


export const verifyPackageById = async (packageId, status) => {
  const token = localStorage.getItem("accessToken");

  try {
    const response = await axios.post(
      `${BASE_URL}/user/verifyPackageById/${packageId}`,
      { Status: status },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        timeout: 10000,
      }
    );

    // success response return
    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    // error response return
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
      status: error.response?.status,
      error: error.response?.data || null,
    };
  }
};



export const verifyAiPackageById = async (packageId, status) => {
  const token = localStorage.getItem("accessToken");

  try {
    const response = await axios.post(
      `${BASE_URL}/user/verifyAiPackageById/${packageId}`,
      { Status: status },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        timeout: 10000,
      }
    );

    // success response return
    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    // error response return
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
      status: error.response?.status,
      error: error.response?.data || null,
    };
  }
};

export const completeProfile = async (data) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const formData = new FormData();
    // Append all form fields
    Object.keys(data).forEach(key => {
      if (key === 'image' && data[key]) {
        formData.append(key, data[key]); // File input
      } else if (data[key]) {
        formData.append(key, data[key]); // Text inputs
      }
    });

    const response = await fetch(`${BASE_URL}/user/completeProfile`, {
      method: "PUT",
      headers: {
        "Authorization": `Bearer ${token}`,
      },
      body: formData,
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Profile completion failed with status ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
};

export const addTeamMember = async (data) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/user/addTeamMember`, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Adding team member failed with status ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
};

export const getTeamMembers = async () => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/user/getTeamMember`, {
      method: "GET",
      headers,
    });

    console.log('getTeamMembers Response Status:', response.status);
    console.log('getTeamMembers Response Headers:', response.headers.get('content-type'));

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Fetching team members failed with status ${response.status}: ${text.slice(0, 100)}...`);
    }

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    return result.data.docs;
  } catch (error) {
    console.error("getTeamMembers API Error:", error.message);
    throw error;
  }
};

export const getDashboard = async () => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/user/getDashboard`, {
      method: "GET",
      headers,
    });

    console.log('getDashboard Response Status:', response.status);
    console.log('getDashboard Response Headers:', response.headers.get('content-type'));

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Fetching dashboard data failed with status ${response.status}: ${text.slice(0, 100)}...`);
    }

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    return result.data;
  } catch (error) {
    console.error("getDashboard API Error:", error.message);
    throw error;
  }
};

export const getPorts = async (country = '', search = '') => {
  try {
    const token = localStorage.getItem('accessToken');
    const params = new URLSearchParams();
    if (country) params.append('country', country);
    if (search) params.append('search', search);

    const url = `${BASE_URL}/ports?${params.toString()}`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `Failed to fetch ports: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("getPorts API Error:", error);
    throw error;
  }
};

export const updateDriverStatus = async (driverId, userStatus) => {
  try {
    const token = localStorage.getItem('accessToken');
    const response = await fetch(`${BASE_URL}/driversAndFleet/editDriver/${driverId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify({ userStatus }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data?.message || "Failed to update driver status");
    }

    return data;
  } catch (error) {
    console.error("API Error in updateDriverStatus:", error);
    throw error.message || "Something went wrong while updating driver status";
  }
};




export const getVehicleFleetForDriver = async (page = 1) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/user/getVehicleFleetForDriver?page=${page}`, {
      method: "GET",
      headers,
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Fetching vehicle fleet failed with status ${response.status}: ${text.slice(0, 100)}...`);
    }

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    console.log(`API response for page ${page}:`, result.data); // Debug log
    return result.data;
  } catch (error) {
    console.error(`getVehicleFleetForDriver API Error (page ${page}):`, error.message);
    throw error;
  }
};

export const addShipment = async (data) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/user/addShipment`, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Add shipment failed with status ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("addShipment API Error:", error.message);
    throw error;
  }
};

export const getAllShipment = async (params = {}) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    // Convert arrays into repeated query params or comma-separated
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        // ✅ Option 1: repeated query params -> ?statuses=IN_TRANSIT&statuses=DELIVERED
        value.forEach(v => searchParams.append(key, v));

        // ✅ Option 2 (if backend expects comma-separated): 
        // searchParams.set(key, value.join(","));
      } else if (value !== undefined && value !== null && value !== "") {
        searchParams.set(key, value);
      }
    });

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(
      `${BASE_URL}/user/getAllShipment?${searchParams.toString()}`,
      { method: "GET", headers }
    );

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Fetching shipments failed with status ${response.status}: ${text.slice(0, 100)}...`);
    }

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    return result.data;
  } catch (error) {
    console.error("getAllShipment API Error:", error.message);
    throw error;
  }
};

export const getAllShipmentExport = async (params = {}) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    // Convert arrays into repeated query params or comma-separated
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        // ✅ Option 1: repeated query params -> ?statuses=IN_TRANSIT&statuses=DELIVERED
        value.forEach(v => searchParams.append(key, v));

        // ✅ Option 2 (if backend expects comma-separated): 
        // searchParams.set(key, value.join(","));
      } else if (value !== undefined && value !== null && value !== "") {
        searchParams.set(key, value);
      }
    });

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(
      `${BASE_URL}/Company/getAllShipmentExport?${searchParams.toString()}`,
      { method: "GET", headers }
    );

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Fetching shipments failed with status ${response.status}: ${text.slice(0, 100)}...`);
    }

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    return result.data;
  } catch (error) {
    console.error("getAllShipment API Error:", error.message);
    throw error;
  }
};
export const getShipment = async (id) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/user/getShipment/${id}`, {
      method: "GET",
      headers,
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Fetching shipment failed with status ${response.status}: ${text.slice(0, 100)}...`);
    }

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    return result.data;
  } catch (error) {
    console.error(`getShipment API Error (id: ${id}):`, error.message);
    throw error;
  }
};



export const getShipmentExport = async (id) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/Drivers/getShipmentById/${id}`, {
      method: "GET",
      headers,
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Fetching shipment failed with status ${response.status}: ${text.slice(0, 100)}...`);
    }

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    return result.data;
  } catch (error) {
    console.error(`getShipment API Error (id: ${id}):`, error.message);
    throw error;
  }
};
export const updateShipmentDetails = async (id, data) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/user/updateShipmentDetails/${id}`, {
      method: "PUT",
      headers,
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Updating shipment failed with status ${response.status}: ${text.slice(0, 100)}...`);
    }

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error(`updateShipmentDetails API Error (id: ${id}):`, error.message);
    throw error;
  }
};


export const assignedShipmentToDriver = async (id, data) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/User/assignedShipmentToDriver/${id}`, {
      method: "PUT",
      headers,
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Updating shipment failed with status ${response.status}: ${text.slice(0, 100)}...`);
    }

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error(`updateShipmentDetails API Error (id: ${id}):`, error.message);
    throw error;
  }
};

export const getDashboardData = async () => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/dispatch/getDashboardData`, {
      method: "GET",
      headers,
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Fetching dashboard data failed with status ${response.status}: ${text.slice(0, 100)}...`);
    }

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    return result.data;
  } catch (error) {
    console.error("getDashboardData API Error:", error.message);
    throw error;
  }
};




export const getDispatchShipment = async (params = {}) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const queryString = new URLSearchParams({
      type: params.type || '',
      page: params.page || '',
      limit: params.limit || '',
      origin: params.origin || '',
      status: params.status || '',
      bookingNumber: params.bookingNumber || ''
    }).toString();

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/dispatch/getAllShipment?${queryString}`, {
      method: "GET",
      headers,
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Fetching shipments failed with status ${response.status}: ${text.slice(0, 100)}...`);
    }

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    return result.data;
  } catch (error) {
    console.error("getDispatchShipment API Error:", error.message);
    throw error;
  }
};

// getDispatchShipment by ID (previously getDiShipment)
export const getDispatchShipmentById = async (id) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/dispatch/getShipment/${id}`, {
      method: "GET",
      headers,
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Fetching shipment failed with status ${response.status}: ${text.slice(0, 100)}...`);
    }

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    return result.data;
  } catch (error) {
    console.error(`getDispatchShipmentById API Error (id: ${id}):`, error.message);
    throw error;
  }
};

// export const createInvoice = async (invoiceData) => {
//   try {
//     const token = localStorage.getItem('accessToken');
//     if (!token) {
//       throw new Error('Access token not found in localStorage');
//     }

//     const headers = {
//       "Content-Type": "application/json",
//       "Authorization": `Bearer ${token}`,
//     };

//     const response = await fetch(`${BASE_URL}/invoiceAndPayments/createInvoices`, {
//       method: "POST",
//       headers,
//       body: JSON.stringify(invoiceData),
//     });

//     const contentType = response.headers.get("content-type");
//     if (!contentType || !contentType.includes("application/json")) {
//       const text = await response.text();
//       throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
//     }

//     const result = await response.json();
//     if (!response.ok) {
//       throw new Error(result.message || `Creating invoice failed with status ${response.status}`);
//     }

//     return result;
//   } catch (error) {
//     console.error("createInvoice API Error:", error.message);
//     throw error;
//   }
// };
// apiService.js

// apiService.js
export const createInvoices = async (data) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/invoiceAndPayments/createInvoices`, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Invoice creation failed with status ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("createInvoices API Error:", error.message);
    throw error;
  }
};

export const verifyInvoicesById = async (id, data) => {
  try {
    // const token = localStorage.getItem('accessToken');
    // if (!token) {
    //   throw new Error('Access token not found in localStorage');
    // }

    const headers = {
      "Content-Type": "application/json",
      // "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/user/verifyInvoicesById/${id}`, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Invoice creation failed with status ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("createInvoices API Error:", error.message);
    throw error;
  }
};



export const getAllShipmentForPOD = async (params = {}) => {
  try {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      throw new Error("Access token not found in localStorage");
    }

    // Build query params dynamically (remove empty values)
    const queryParams = new URLSearchParams(
      Object.entries(params).reduce((acc, [key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          acc[key] = value;
        }
        return acc;
      }, {})
    ).toString();

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(
      `${BASE_URL}/proofOfDelivery/getAllShipment?${queryParams}`,
      {
        method: "GET",
        headers,
      }
    );

    let result;
    try {
      result = await response.json();
    } catch (jsonError) {
      const text = await response.text();
      throw new Error(
        `Expected JSON, but received: ${text.slice(0, 100)}...`
      );
    }

    if (!response.ok) {
      throw new Error(
        result.message ||
        `Failed to fetch shipments with status ${response.status}: ${JSON.stringify(
          result
        )}`
      );
    }

    return result;
  } catch (error) {
    console.error("getAllShipmentForPOD API Error:", error.message);
    throw error;
  }
};


export const getAllInvoices = async ({ page = 1, limit = 10, paymentMethod = '', status = '', fromDate = '', toDate = '' } = {}) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const queryParams = new URLSearchParams({
      page,
      limit,
      ...(paymentMethod && { paymentMethod }),
      ...(status && { status }),
      ...(fromDate && { fromDate }),
      ...(toDate && { toDate }),
    }).toString();

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/invoiceAndPayments/getAllInvoices?${queryParams}`, {
      method: "GET",
      headers,
    });

    let result;
    try {
      result = await response.json();
    } catch (jsonError) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    if (!response.ok) {
      throw new Error(result.message || `Failed to fetch invoices with status ${response.status}: ${JSON.stringify(result)}`);
    }

    return result;
  } catch (error) {
    console.error("getAllInvoices API Error:", error.message);
    throw error;
  }
};


export const addDriver = async (formData) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const response = await fetch(`${BASE_URL}/driversAndFleet/addDriver`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        // Don't set Content-Type header - let the browser set it automatically
      },
      body: formData,
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Failed to add driver with status ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("addDriver API Error:", error.message);
    throw error;
  }
};
export const getAllDriver = async (
  page = '',
  limit = '',
  status = '',
  fromDate = '',
  toDate = '',
  lng = '',
  lat = '',
  distance = ''
) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Authentication token not found in localStorage');
    }

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    const queryParams = new URLSearchParams({
      page,
      limit,
      status,
      fromDate,
      toDate,
      lng,
      lat,
      distance,
    }).toString();

    const url = `${BASE_URL}/driversAndFleet/getAllDriver?${queryParams}`;

    const response = await fetch(url, {
      method: "GET",
      headers,
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || `Failed to fetch drivers with status ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
};

export const getLiveShipment = async (token) => {
  try {
    const response = await fetch(`${BASE_URL}/user/getLiveShipment`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || 'Failed to fetch live shipments');
    }

    return result.data; // assuming your data is under `data`
  } catch (error) {
    console.error('getLiveShipment API Error:', error.message);
    throw error;
  }
};
export const getVehicleFleetForDriver6 = async () => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Authentication token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    const url = `${BASE_URL}/Driver/getVehicleFleetForDriver`; // Adjusted URL based on BASE_URL
    const response = await fetch(url, {
      method: "GET",
      headers,
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Failed to fetch vehicle fleet with status ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
};

export const updateShipmentLoadDetails = async (id, data) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/dispatch/updateShipmentLoadDetails/${id}`, {
      method: "PUT",
      headers,
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Update failed with status ${response.status}: ${text.slice(0, 100)}...`);
    }

    return await response.json();
  } catch (error) {
    console.error("updateShipmentLoadDetails API Error:", error.message);
    throw error;
  }
};








export const updateSealNumber = async (id, data) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/User/updateShipmentDetails/${id}`, {
      method: "PUT",
      headers,
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Update failed with status ${response.status}: ${text.slice(0, 100)}...`);
    }

    return await response.json();
  } catch (error) {
    console.error("updateShipmentLoadDetails API Error:", error.message);
    throw error;
  }
};





// export const companyDetailsUpdate = async (data) => {
//   try {
//     const token = localStorage.getItem('accessToken');
//     if (!token) throw new Error('No access token found');

//     const response = await fetch(`${BASE_URL}/user/companyDetailsUpdate`, {
//       method: "PUT",
//       headers: {
//         "Content-Type": "application/json",
//         "Authorization": `Bearer ${token}`
//       },
//       body: JSON.stringify(data)
//     });

//     if (!response.ok) {
//       const errorData = await response.json();
//       throw new Error(errorData.message || 'Failed to update company details');
//     }

//     return await response.json();
//   } catch (error) {
//     console.error("companyDetailsUpdate error:", error);
//     throw error;
//   }
// };

// export const contactAndAddressUpdate = async (data) => {
//   try {
//     const token = localStorage.getItem('accessToken');
//     if (!token) throw new Error('No access token found');

//     const response = await fetch(`${BASE_URL}/user/contactAndAddressUpdate`, {
//       method: "PUT",
//       headers: {
//         "Content-Type": "application/json",
//         "Authorization": `Bearer ${token}`
//       },
//       body: JSON.stringify(data)
//     });

//     if (!response.ok) {
//       const errorData = await response.json();
//       throw new Error(errorData.message || 'Failed to update contact details');
//     }

//     return await response.json();
//   } catch (error) {
//     console.error("contactAndAddressUpdate error:", error);
//     throw error;
//   }
// };

// export const brandingUpdate = async (formData) => {
//   try {
//     const token = localStorage.getItem('accessToken');
//     if (!token) throw new Error('No access token found');

//     const response = await fetch(`${BASE_URL}/user/brandingUpdate`, {
//       method: "PUT",
//       headers: {
//         "Authorization": `Bearer ${token}`
//       },
//       body: formData // Note: Don't set Content-Type header for FormData
//     });

//     if (!response.ok) {
//       const errorData = await response.json();
//       throw new Error(errorData.message || 'Failed to update branding');
//     }

//     return await response.json();
//   } catch (error) {
//     console.error("brandingUpdate error:", error);
//     throw error;
//   }
// };

// export const legalAndRegistrationDocs = async (formData) => {
//   try {
//     const token = localStorage.getItem('accessToken');
//     if (!token) throw new Error('No access token found');

//     const response = await fetch(`${BASE_URL}/user/legalAndRegistrationDocs`, {
//       method: "PUT",
//       headers: {
//         "Authorization": `Bearer ${token}`
//       },
//       body: formData // Note: Don't set Content-Type header for FormData
//     });

//     if (!response.ok) {
//       const errorData = await response.json();
//       throw new Error(errorData.message || 'Failed to update legal docs');
//     }

//     return await response.json();
//   } catch (error) {
//     console.error("legalAndRegistrationDocs error:", error);
//     throw error;
//   }
// };

// export const getSubscriptionOverview = async () => {
//   try {
//     const token = localStorage.getItem('accessToken');
//     if (!token) throw new Error('No access token found');

//     const response = await fetch(`${BASE_URL}/user/getSubscriptionOverview`, {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//         "Authorization": `Bearer ${token}`
//       }
//     });

//     if (!response.ok) {
//       const errorData = await response.json();
//       throw new Error(errorData.message || 'Failed to fetch subscription data');
//     }

//     return await response.json();
//   } catch (error) {
//     console.error("getSubscriptionOverview error:", error);
//     throw error;
//   }
// };

export const getShipmentByIdPod = async (id) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/Drivers/getShipmentById/${id}`, {
      method: "GET",
      headers,
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Fetching shipment failed with status ${response.status}: ${text.slice(0, 100)}...`);
    }

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    return result.data;
  } catch (error) {
    console.error(`getShipment API Error (id: ${id}):`, error.message);
    throw error;
  }
};
export const updateCompanyDetails = async (data) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/user/companyDetailsUpdate`, {
      method: "PUT",
      headers,
      body: JSON.stringify(data),
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Company details update failed with status ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
};

export const updateContactAndAddress = async (data) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/user/contactAndAddressUpdate`, {
      method: "PUT",
      headers,
      body: JSON.stringify(data),
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Contact update failed with status ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
};

export const updateBranding = async (formData) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    // Note: Don't set Content-Type header - the browser will set it automatically with the correct boundary
    const headers = {
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/user/brandingUpdate`, {
      method: "PUT",
      headers,
      body: formData, // Pass FormData directly
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Branding update failed with status ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
};

export const updateLegalDocs = async (formData) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/user/legalAndRegistrationDocs`, {
      method: "PUT",
      headers,
      body: formData,
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Legal docs update failed with status ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
};

export const getSubscriptionOverview = async () => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/user/getSubscriptionOverview`, {
      method: "GET",
      headers,
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Subscription fetch failed with status ${response.status}`);
    }

    return result.data;
  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
};
// apiService.js


// Existing imports and functions remain unchanged...

// Add Notification APIs
export const addNotification = async (notificationData) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/notify/add`, {
      method: "POST",
      headers,
      body: JSON.stringify(notificationData),
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Add notification failed with status ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
};

export const getAllNotificationsAdmin = async () => {
  try {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      console.error("Access token missing");
      return [];
    }

    const response = await axios.get(`${BASE_URL}/notify/getAllNotification`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    // Axios wraps the response in `data`
    return response.data?.data || [];
  } catch (error) {
    console.error("API Error:", error.message);
    return [];
  }
};

export const getUserNotifications = async () => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/notify/listMyNotification`, {
      method: "GET",
      headers,
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Fetch user notifications failed with status ${response.status}`);
    }

    return result.data;
  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
};

export const getNotificationById = async (id) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/notify/get/${id}`, {
      method: "GET",
      headers,
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Fetch notification by ID failed with status ${response.status}`);
    }

    return result.data;
  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
};

// Add this to your ApiService.js file
// export const getProfile = async () => {
//   try {
//     const userId = localStorage.getItem('userId');
//     if (!userId) {
//       throw new Error('User ID not found in localStorage');
//     }

//     const response = await fetch(`${BASE_URL}/user/getProfile`, {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//         "Authorization": `Bearer ${localStorage.getItem('accessToken')}`
//       },
//     });

//     const contentType = response.headers.get("content-type");
//     if (!contentType || !contentType.includes("application/json")) {
//       const text = await response.text();
//       throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
//     }

//     const result = await response.json();
//     if (!response.ok) {
//       throw new Error(result.message || `Fetch profile failed with status ${response.status}`);
//     }

//     return result.data;
//   } catch (error) {
//     console.error("API Error:", error.message);
//     throw error;
//   }
// };
export const getProfile = async ({ signal } = {}) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const response = await fetch(`${BASE_URL}/user/getProfile`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      signal, // Pass AbortController signal
    });

    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Fetch profile failed with status ${response.status}`);
    }

    return result.data;
  } catch (error) {
    console.error('API Error:', error.message);
    throw error;
  }
};
// In your apiService.js
export const updateProfile = async (data) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const formData = new FormData();
    // Log FormData entries for debugging
    const formDataEntries = {};
    Object.keys(data).forEach(key => {
      if (key === 'image' && data[key] instanceof File) {
        formData.append(key, data[key]);
        formDataEntries[key] = data[key].name;
      } else if (data[key] !== undefined && data[key] !== null && data[key] !== '') {
        formData.append(key, data[key]);
        formDataEntries[key] = data[key];
      }
    });
    console.log('FormData being sent:', formDataEntries);

    const response = await fetch(`${BASE_URL}/manageAccount/update`, {
      method: "PUT",
      headers: {
        "Authorization": `Bearer ${token}`,
      },
      body: formData,
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    console.log('API Response:', result); // Log the full response for debugging
    if (!response.ok) {
      throw new Error(result.message || `Profile update failed with status ${response.status}`);
    }

    return result.data;
  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
};
// export const getAgoraToken = async (userId) => {
//   try {
//     const response = await fetch(`${BASE_URL}/user/generateAccessToken`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ UserId: userId }),
//     });

//     const result = await response.json();
//     if (!response.ok) throw new Error(result.message);
//     return result;
//   } catch (error) {
//     console.error("Agora Token Error:", error.message);
//     throw error;
//   }
// };
export const getAgoraToken = async (userId) => {
  try {
    if (!userId || typeof userId !== 'string' || userId.trim() === '') {
      throw new Error('Invalid or missing userId');
    }

    console.log('Requesting Agora token for userId:', userId);
    const response = await fetch(`${BASE_URL}/user/generateAccessToken`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ UserId: userId }),
    });

    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    console.log('Agora token response:', result);

    if (!response.ok) {
      throw new Error(result.message || `Failed to fetch Agora token with status (${response.status})`);
    }

    if (!result.token || !result.lawyerChannel) {
      throw new Error('Token or lawyerChannel missing in response');
    }

    return result;
  } catch (error) {
    console.error('Agora Token Error:', error.message);
    throw error;
  }
};


export const sendPushNotification = async (userId, type, channelName, agoraToken, additionalData = {}) => {
  try {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${accessToken}`,
    };

    const payload = {
      type,
      channelName,
      agoraToken,
      ...additionalData, // Spread additionalData to include id and fullName
    };

    console.log("🟦 Sending push notification payload:", {
      to: userId,
      payload,
    });

    const response = await fetch(`${BASE_URL}/user/SendPushNotification/${userId}`, {
      method: "POST",
      headers,
      body: JSON.stringify(payload),
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Push notification failed with status ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
};
export const checkProfileExists = async (userId) => {
  try {
    const profile = await getProfile(); // Reuse the existing getProfile function
    return !!profile; // Return true if profile data exists, false otherwise
  } catch (error) {
    console.error("Error checking profile existence:", error.message);
    return false; // Assume profile doesn't exist if the API call fails
  }
};
// apiService.js (append these to your existing file)

// ShipGo APIs
export const postContainerTracking = async (data) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/shipGo/postContainerInfoWithBl`, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Post container tracking failed with status ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("postContainerTracking API Error:", error.message);
    throw error;
  }
};

export const postContainerInfoWithBl = async (data) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/shipGo/postContainerInfoWithBl`, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Post container info with BL failed with status ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("postContainerInfoWithBl API Error:", error.message);
    throw error;
  }
};

export const postCustomContainerForm = async (data) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/shipGo/postCustomContainerForm`, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Post custom container form failed with status ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("postCustomContainerForm API Error:", error.message);
    throw error;
  }
};

export const postContainerInfo = async (data) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/shipGo/postContainerInfo`, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Post container info failed with status ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("postContainerInfo API Error:", error.message);
    throw error;
  }
};

// src/utils/validation.js
export const isValidDate = (dateString) => {
  // Check if the input matches YYYY-MM-DD format
  const regex = /^\d{4}-\d{2}-\d{2}$/;
  if (!regex.test(dateString)) {
    return false;
  }

  // Parse the date and check if it's valid
  const date = new Date(dateString);
  const isValid = !isNaN(date.getTime());

  // Ensure the date string matches the parsed date (e.g., prevents invalid dates like 2025-02-30)
  if (isValid) {
    const [year, month, day] = dateString.split('-').map(Number);
    return (
      date.getFullYear() === year &&
      date.getMonth() + 1 === month && // getMonth() is 0-based
      date.getDate() === day
    );
  }

  return false;
};
export const getContainerInfo = async (containerNumber = '') => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const url = `${BASE_URL}/shipGo/getContainerInfo${containerNumber ? `?containerNumber=${containerNumber}` : ''}`;

    const response = await fetch(url, {
      method: "GET",
      headers,
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Get container info failed with status ${response.status}`);
    }

    return Array.isArray(result.data) ? result.data : [result.data];
  } catch (error) {
    console.error("getContainerInfo API Error:", error.message);
    throw error;
  }
};
export const getShippingLineList = async () => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/shipGo/GetShippingLineList`, {
      method: "GET",
      headers,
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Get shipping line list failed with status ${response.status}`);
    }

    return result.data;
  } catch (error) {
    console.error("getShippingLineList API Error:", error.message);
    throw error;
  }
};
export const getPackageReport = async (params = {}) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    // Construct query string from params
    const query = new URLSearchParams(params).toString();
    const url = `${BASE_URL}/user/getPackageReport${query ? `?${query}` : ''}`;

    const response = await fetch(url, {
      method: "GET",
      headers,
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Get package report failed with status ${response.status}`);
    }

    return result.data;
  } catch (error) {
    console.error("getPackageReport API Error:", error.message);
    throw error;
  }
};

// apiService.js

// ... (other existing imports and functions)

// Add the getAllDispatchReport API
export const getAllDispatchReport = async (params = {}) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const queryString = new URLSearchParams({
      page: params.page || '1',
      limit: params.limit || '10',
      fromDate: params.fromDate || '',
      toDate: params.toDate || '',
      status: params.status || '',
    }).toString();

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/User/getAllDispatchReport?${queryString}`, {
      method: "GET",
      headers,
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Fetch dispatch reports failed with status ${response.status}`);
    }

    return result.data;
  } catch (error) {
    console.error("getAllDispatchReport API Error:", error.message);
    throw error;
  }
};
export const markCompleteShipment = async (id) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/Driver/markCompleteShipment/${id}`, {
      method: "POST",
      headers,
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Marking shipment as complete failed with status ${response.status}: ${text.slice(0, 100)}...`);
    }

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error(`markCompleteShipment API Error (id: ${id}):`, error.message);
    throw error;
  }
};
export const addDispatchShipment = async (data) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/user/addDispatchShipment`, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Adding dispatch shipment failed with status ${response.status}: ${text.slice(0, 100)}...`);
    }

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("addDispatchShipment API Error:", error.message);
    throw error;
  }
};
// apiService.js

// ... (other existing imports and functions)

export const getAllAttendance = async (params = {}) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('Access token not found in localStorage');
    }

    const queryString = new URLSearchParams({
      userId: params.userId || '',
      fromDate: params.fromDate || '',
      toDate: params.toDate || '',
      page: params.page || '1',
      limit: params.limit || '10',
    }).toString();

    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${BASE_URL}/Driver/getAllAttendance?${queryString}`, {
      method: "GET",
      headers,
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Expected JSON, but received: ${text.slice(0, 100)}...`);
    }

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || `Fetch attendance data failed with status ${response.status}`);
    }

    return result.data;
  } catch (error) {
    console.error("getAllAttendance API Error:", error.message);
    throw error;
  }
};





export const checkOutAiPackageById = async (id, data) => {
  if (!id) {
    throw new Error("Package ID is required");
  }

  const token = localStorage.getItem("accessToken");
  if (!token) {
    throw new Error("Access token not found");
  }

  try {
    const res = await axios.post(
      `${BASE_URL}/user/checkOutAiPackageById/${id}`,
      data, // no body (safe default)
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return res;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data ||
      error?.message ||
      "Checkout AI package failed";

    console.error("checkOutAiPackageById API Error:", message);
    throw new Error(message);
  }
};

export const createLtlLoad = async (data) => {
  const token = localStorage.getItem("accessToken");
  if (!token) throw new Error("Access token not found");

  try {
    const res = await axios.post(`${BASE_URL}/loads/ltl`, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || "LTL Load creation failed";
    console.error("createLtlLoad API Error:", message);
    throw new Error(message);
  }
};

export const createFtlLoad = async (data) => {
  const token = localStorage.getItem("accessToken");
  if (!token) throw new Error("Access token not found");

  try {
    const res = await axios.post(`${BASE_URL}/loads/ftl`, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || "FTL Load creation failed";
    console.error("createFtlLoad API Error:", message);
    throw new Error(message);
  }
};

export const getSingleLoad = async (id) => {
  const token = localStorage.getItem("accessToken");
  if (!token) throw new Error("Access token not found");

  try {
    const res = await axios.get(`${BASE_URL}/load/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || "Failed to fetch single load";
    console.error("getSingleLoad API Error:", message);
    throw new Error(message);
  }
};

export const getAllLoads = async (params = {}) => {
  const token = localStorage.getItem("accessToken");
  if (!token) throw new Error("Access token not found");

  try {
    const res = await axios.get(`${BASE_URL}/loads/my-posted`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    });
    return res.data;
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || "Failed to fetch loads";
    console.error("getAllLoads API Error:", message);
    throw new Error(message);
  }
};

export const getExportBookingDashboard = async (params = {}) => {
  const token = localStorage.getItem("accessToken");
  if (!token) throw new Error("Access token not found");

  try {
    const res = await axios.get(`${BASE_URL}/User/exportBooking/dashboard`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    });
    return res.data;
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || "Failed to fetch export booking dashboard";
    console.error("getExportBookingDashboard API Error:", message);
    throw new Error(message);
  }
};

export const getExportBookingSummary = async (shipmentId) => {
  const token = localStorage.getItem("accessToken");
  if (!token) throw new Error("Access token not found");

  try {
    const res = await axios.get(`${BASE_URL}/User/exportBooking/${shipmentId}/summary`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || "Failed to fetch export booking summary";
    console.error("getExportBookingSummary API Error:", message);
    throw new Error(message);
  }
};

export const containerPickedUp = async (shipmentId, data) => {
  const token = localStorage.getItem("accessToken");
  if (!token) throw new Error("Access token not found");

  try {
    const res = await axios.post(`${BASE_URL}/Drivers/containerPickedUp/${shipmentId}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || "Failed to submit container pickup";
    console.error("containerPickedUp API Error:", message);
    throw error?.response || new Error(message);
  }
};

export const assignDriverToSlot = async (bookingId, slotId, data) => {
  const token = localStorage.getItem("accessToken");
  if (!token) throw new Error("Access token not found");

  try {
    const res = await axios.post(`${BASE_URL}/User/exportBooking/${bookingId}/slot/${slotId}/assignDriver`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || "Failed to assign driver to slot";
    console.error("assignDriverToSlot API Error:", message);
    throw error?.response || new Error(message);
  }
};

// Cancel Slot — POST /User/exportBooking/:bookingId/slot/:slotId/cancel
export const cancelSlot = async (bookingId, slotId) => {
  const token = localStorage.getItem("accessToken");
  if (!token) throw new Error("Access token not found");

  try {
    const res = await axios.post(`${BASE_URL}/User/exportBooking/${bookingId}/slot/${slotId}/cancel`, {}, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || "Failed to cancel slot";
    console.error("cancelSlot API Error:", message);
    throw error?.response || new Error(message);
  }
};

// Container Loaded - POST /User/exportBooking/:bookingId/slot/:slotId/containerLoaded
export const containerLoadedExport = async (bookingId, slotId, data) => {
  const token = localStorage.getItem("accessToken");
  if (!token) throw new Error("Access token not found");

  try {
    const res = await axios.post(`${BASE_URL}/User/exportBooking/${bookingId}/slot/${slotId}/containerLoaded`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || "Failed to mark container as loaded";
    console.error("containerLoadedExport API Error:", message);
    throw error?.response || new Error(message);
  }
};

// Submit POD - POST /User/exportBooking/:bookingId/slot/:slotId/pod
export const submitPodExport = async (bookingId, slotId, data) => {
  const token = localStorage.getItem("accessToken");
  if (!token) throw new Error("Access token not found");

  try {
    const res = await axios.post(`${BASE_URL}/User/exportBooking/${bookingId}/slot/${slotId}/pod`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || "Failed to submit POD";
    console.error("submitPodExport API Error:", message);
    throw error?.response || new Error(message);
  }
};

// Get Booking Invoices — GET /User/exportBooking/:id/invoices
export const getBookingInvoices = async (bookingId) => {
  const token = localStorage.getItem("accessToken");
  if (!token) throw new Error("Access token not found");

  try {
    const res = await axios.get(`${BASE_URL}/User/exportBooking/${bookingId}/invoices`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || "Failed to fetch invoices";
    console.error("getBookingInvoices API Error:", message);
    throw error?.response || new Error(message);
  }
};

// Reconcile Booking — POST /User/exportBooking/:id/reconcile (admin/support use)
export const reconcileBooking = async (bookingId) => {
  const token = localStorage.getItem("accessToken");
  if (!token) throw new Error("Access token not found");

  try {
    const res = await axios.post(`${BASE_URL}/User/exportBooking/${bookingId}/reconcile`, {}, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || "Failed to reconcile booking";
    console.error("reconcileBooking API Error:", message);
    throw error?.response || new Error(message);
  }
};

// =======================
// CARRIER / LTL / FTL FLOW
// =======================

export const respondToLoad = async (loadId, data) => {
  const token = localStorage.getItem("accessToken");
  if (!token) throw new Error("Access token not found");

  try {
    const res = await axios.post(`${BASE_URL}/loads/${loadId}/respond`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || "Failed to respond to load";
    console.error("respondToLoad API Error:", message);
    throw error?.response || new Error(message);
  }
};

export const getLoadResponses = async (loadId) => {
  const token = localStorage.getItem("accessToken");
  if (!token) throw new Error("Access token not found");

  try {
    const res = await axios.get(`${BASE_URL}/loads/${loadId}/responses`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || "Failed to fetch load responses";
    console.error("getLoadResponses API Error:", message);
    throw error?.response || new Error(message);
  }
};

export const selectCarrierForLoad = async (loadId, data) => {
  const token = localStorage.getItem("accessToken");
  if (!token) throw new Error("Access token not found");

  try {
    const res = await axios.post(`${BASE_URL}/loads/${loadId}/select-carrier`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || "Failed to select carrier";
    console.error("selectCarrierForLoad API Error:", message);
    throw error?.response || new Error(message);
  }
};

export const updateLoadStatus = async (loadId, data) => {
  const token = localStorage.getItem("accessToken");
  if (!token) throw new Error("Access token not found");

  try {
    const res = await axios.post(`${BASE_URL}/loads/${loadId}/status`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || "Failed to update load status";
    console.error("updateLoadStatus API Error:", message);
    throw error?.response || new Error(message);
  }
};

export const submitLoadPod = async (loadId, data) => {
  const token = localStorage.getItem("accessToken");
  if (!token) throw new Error("Access token not found");

  try {
    const res = await axios.post(`${BASE_URL}/loads/${loadId}/pod`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || "Failed to submit load POD";
    console.error("submitLoadPod API Error:", message);
    throw error?.response || new Error(message);
  }
};

export const createCarShippingLoad = async (data) => {
  const token = localStorage.getItem("accessToken");
  if (!token) throw new Error("Access token not found");

  try {
    const res = await axios.post(`${BASE_URL}/loads/car-shipping`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || "Failed to create car shipping load";
    console.error("createCarShippingLoad API Error:", message);
    throw error?.response || new Error(message);
  }
};

// =======================
// NEW UNIFIED LOAD POST API (Box/Package support)
// POST /api/v1/loads — works for LTL & FTL with shippingItemType
// =======================

export const postLoad = async (data) => {
  const token = localStorage.getItem("accessToken");
  if (!token) throw new Error("Access token not found");

  try {
    const res = await axios.post(`${BASE_URL}/loads`, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (error) {
    const errData = error?.response?.data;
    // Backend returns 400 with { errors: [...] } array
    if (errData?.errors && Array.isArray(errData.errors)) {
      throw { errors: errData.errors, message: errData.message || "Validation failed" };
    }
    const message = errData?.message || error?.message || "Load creation failed";
    console.error("postLoad API Error:", message);
    throw new Error(message);
  }
};

// =======================
// GEOCODING HELPER (OpenStreetMap Nominatim — no API key needed)
// =======================
export const geocodeAddress = async (address) => {
  try {
    const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}&limit=1`;
    const res = await fetch(url, {
      headers: { "Accept-Language": "en" },
    });
    const data = await res.json();
    if (data && data.length > 0) {
      return { lat: parseFloat(data[0].lat), lng: parseFloat(data[0].lon), display_name: data[0].display_name };
    }
    throw new Error(`Could not geocode address: "${address}"`);
  } catch (error) {
    console.error("geocodeAddress Error:", error.message);
    throw error;
  }
};



// PUT /api/v1/Company/updateTruckDetails/:id
export const updateCompanyTruckDetails = async (truckId, data) => {
  const token = localStorage.getItem("accessToken");
  if (!token) throw new Error("Access token not found");

  try {
    const res = await axios.put(`${BASE_URL}/Company/updateTruckDetails/${truckId}`, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || "Failed to update truck details";
    console.error("updateCompanyTruckDetails API Error:", message);
    throw new Error(message);
  }
};

// GET /api/v1/loads/available (with filters)
export const getAvailableLoads = async (params = {}) => {
  const token = localStorage.getItem("accessToken");
  if (!token) throw new Error("Access token not found");

  try {
    const res = await axios.get(`${BASE_URL}/loads/available`, {
      headers: { Authorization: `Bearer ${token}` },
      params,
    });
    return res.data;
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || "Failed to fetch available loads";
    console.error("getAvailableLoads API Error:", message);
    throw new Error(message);
  }
};

// NebuBots Agreement APIs
const NEBUBOTS_BASE_URL = "https://nebubots.net/api/v1";

export const getCurrentAgreement = async (audience = "posting_user") => {
  const token = localStorage.getItem("accessToken");
  try {
    const res = await axios.get(`${NEBUBOTS_BASE_URL}/agreements/current`, {
      params: { audience },
      headers: {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    });
    return res.data;
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || "Failed to fetch agreement";
    console.error("getCurrentAgreement API Error:", message);
    throw error;
  }
};

export const acceptAgreement = async ({ agreementId, fullName }) => {
  const token = localStorage.getItem("accessToken");
  try {
    const res = await axios.post(
      `${NEBUBOTS_BASE_URL}/agreements/accept`,
      { agreementId, fullName },
      {
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      }
    );
    return res.data;
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || "Failed to accept agreement";
    console.error("acceptAgreement API Error:", message);
    throw error;
  }
};

// NebuDash Profile APIs
export const getNebudashProfile = async () => {
  const token = localStorage.getItem("accessToken");
  try {
    const res = await axios.get(`${NEBUBOTS_BASE_URL}/nebudash/profile`, {
      headers: {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    });
    return res.data;
  } catch (error) {
    console.error("getNebudashProfile API Error:", error?.response?.data || error.message);
    throw error;
  }
};

export const updateNebudashProfile = async (profileData) => {
  const token = localStorage.getItem("accessToken");
  try {
    const res = await axios.post(
      `${NEBUBOTS_BASE_URL}/nebudash/profile`,
      profileData,
      {
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error("updateNebudashProfile API Error:", error?.response?.data || error.message);
    throw error;
  }
};

